import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M18.879 6.712a.75.75 0 0 1 0 1.061L17.482 9.17l-2.651-2.651 1.396-1.396a.75.75 0 0 1 1.06 0zm-2.457 3.518L13.77 7.578l-7.78 7.78a.75.75 0 0 0-.203.376l-.663 3.142 3.142-.663a.75.75 0 0 0 .375-.203zm-7.847 9.451a2.25 2.25 0 0 0 1.127-.61L19.939 8.834a2.25 2.25 0 0 0 0-3.182L18.35 4.06a2.25 2.25 0 0 0-3.183 0L4.93 14.298c-.308.308-.52.7-.61 1.127l-.9 4.269a.75.75 0 0 0 .887.888z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }